import { render } from "./Textmedia.vue?vue&type=template&id=00bc6dd6"
import script from "./Textmedia.vue?vue&type=script&lang=js"
export * from "./Textmedia.vue?vue&type=script&lang=js"

import "./Textmedia.vue?vue&type=style&index=0&id=00bc6dd6&lang=scss"

import exportComponent from "/Users/david.haas/Documents/Projects/VSC/ommax-employer-branding-lp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__